export default __webpack_public_path__ + "static/media/trackinfo_tunnel.32f3bbb1.webp";